import CommunicationCard from "./CommunicationCard"

export default  CommunicationCard;
